/* eslint-disable */
import React from 'react';
import { Star } from 'lucide-react';

// Read-only star display. Supports 0.1 increments using CSS clip.
const StarRating = ({ value = 0, size = 16, color = '#1a1410', emptyColor = '#cdc2b1', showNumber = false, className = '' }) => {
  const v = Math.max(0, Math.min(5, Number(value) || 0));
  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      <div className="inline-flex items-center" aria-label={`Rating ${v.toFixed(1)} out of 5`}>
        {[0, 1, 2, 3, 4].map((i) => {
          const fill = Math.max(0, Math.min(1, v - i));
          return (
            <span key={i} className="relative inline-block" style={{ width: size, height: size }}>
              <Star
                width={size}
                height={size}
                strokeWidth={1.4}
                style={{ color: emptyColor }}
                className="absolute inset-0"
              />
              <span
                className="absolute inset-0 overflow-hidden"
                style={{ width: `${fill * 100}%` }}
              >
                <Star
                  width={size}
                  height={size}
                  strokeWidth={1.4}
                  fill={color}
                  style={{ color }}
                />
              </span>
            </span>
          );
        })}
      </div>
      {showNumber && (
        <span className="font-serif text-base text-[#1a1410]">{v.toFixed(1)}</span>
      )}
    </div>
  );
};

export default StarRating;
